(function () {
    'use strict';

    angular.module("imApp").factory("oeeStateRemarkService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 247,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 248,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
